import { IconButton, Modal } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React, { useEffect, useReducer, useState } from 'react';
import {
  EMAIL_SOCIAL_TEXT_COMPONENT,
  EMAIL_TEXT_COMPONENT,
  FONT_LIST,
  FONT_SIZE_LIST,
  FONT_STYLE_LIST,
} from '../../../../constants/EmailServicesConst';
import BackgroundColor from '../../../../shared/email-services/background-color/BackgroundColor';
import DividerLine from '../../../../shared/email-services/divider-line/DividerLine';
import Hyperlink from '../../../../shared/email-services/hyperlink/Hyperlink';
import PaddingComponent from '../../../../shared/email-services/padding-component/PaddingComponent';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import './TextComponent.scss';

const TextComponent = (props) => {
  const {
    onItemChange,
    componentObj,
    componentId,
    subId,
    isHex,
    isVariable,
    activeNdx,
    placeHolderText,
    isFontStyleDD,
    isRemovable,
    onRemoveComponent,
    isHyperlink,
    maxLength,
  } = props;
  const [isHsxColor, setIsHsxColor] = useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '52%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: 700,
    bgcolor: 'white',
    borderRadius: '20px',
    border: 'none',
    p: 4,
    outline: 'none',
    overflow: 'auto',
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    text: {
      value: '',
      fieldName: 'Text',
      placeholder: placeHolderText || undefined,
      errors: {},
      validations: [],
      tab: 0,
    },
    fontStyle: {
      value: '',
      fieldName: 'Font Style',
      errors: {},
      validations: [],
      tab: 0,
    },
    font: {
      value: '',
      fieldName: 'Font',
      errors: {},
      validations: [],
      tab: 0,
    },
    fontSize: {
      value: 14,
      fieldName: 'Font Size',
      errors: {},
      validations: [],
      tab: 0,
    },
    alignment: {
      value: 'center',
      fieldName: 'alignment',
      errors: {},
      validations: [],
      tab: 0,
    },
    textColor: {
      value: '',
      fieldName: 'Text Color',
      errors: {},
      validations: [],
      tab: 0,
    },
    padding: {
      value: false,
      fieldName: 'Padding',
      errors: {},
      validations: [],
      tab: 0,
    },
    top: {
      value: '10',
      fieldName: 'Top',
      errors: {},
      validations: [],
      tab: 0,
    },
    bottom: {
      value: '10',
      fieldName: 'Bottom',
      errors: {},
      validations: [],
      tab: 0,
    },
    left: {
      value: '10',
      fieldName: 'Left',
      errors: {},
      validations: [],
      tab: 0,
    },
    right: {
      value: '10',
      fieldName: 'Right',
      errors: {},
      validations: [],
      tab: 0,
    },
    hexCode: {
      value: '#82828214',
      fieldName: 'Hex Code',
      errors: {},
      validations: [],
      tab: 0,
    },
    bold: {
      value: false,
      fieldName: 'Bold',
      errors: {},
      validations: [],
      tab: 0,
    },
    italic: {
      value: false,
      fieldName: 'Italic',
      errors: {},
      validations: [],
      tab: 0,
    },
    underline: {
      value: false,
      fieldName: 'Underline',
      errors: {},
      validations: [],
      tab: 0,
    },
    linkedIn: {
      value: '',
      fieldName: 'LinkedIn',
      errors: {},
      validations: ['validHttpsUrl'],
      placeholder: 'Enter Link',
      tab: 0,
    },
    facebook: {
      value: '',
      fieldName: 'Facebook',
      errors: {},
      validations: ['validHttpsUrl'],
      placeholder: 'Enter Link',
      tab: 0,
    },
    twitter: {
      value: '',
      fieldName: 'Twitter',
      errors: {},
      validations: ['validHttpsUrl'],
      placeholder: 'Enter Link',
      tab: 0,
    },
    instagram: {
      value: '',
      fieldName: 'Instagram',
      errors: {},
      validations: ['validHttpsUrl'],
      placeholder: 'Enter Link',
      tab: 0,
    },
    youTube: {
      value: '',
      fieldName: 'YouTube',
      errors: {},
      validations: ['validHttpsUrl'],
      placeholder: 'Enter Link',
      tab: 0,
    },
    hyperLink: {
      value: [],
      fieldName: 'Hyperlink',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const validate = () => {
    const isValid = formDataValidate(formData, false);
    return isValid;
  };

  useEffect(() => {
    const currFormData = { ...formData };
    if (componentObj && Object.keys(componentObj).length > 0) {
      for (let field in currFormData) {
        if (componentObj[field] !== undefined) currFormData[field].value = componentObj[field];
      }
    }
    setFormData(currFormData);
  }, [componentId, activeNdx]);

  const setHyperLinkValue = () => {
    if (!isHyperlink) return undefined;
    if (formData.hyperLink?.value?.length > 0) return formData.hyperLink.value;
    return [];
  };

  useEffect(() => {
    let extraInput = undefined;
    if (componentId === EMAIL_SOCIAL_TEXT_COMPONENT) {
      extraInput = {
        linkedIn: formData.linkedIn?.value,
        facebook: formData.facebook?.value,
        twitter: formData.twitter?.value,
        instagram: formData.instagram?.value,
        youTube: formData.youTube?.value,
      };
    }
    onItemChange({
      id: componentId,
      subId: subId || null,
      text: formData.text.value,
      font: formData.font.value,
      fontStyle: formData.fontStyle.value,
      fontSize: formData.fontSize.value ? Number(formData.fontSize.value) : 14,
      textColor: formData.textColor.value,
      padding: formData.padding.value,
      top: Number(formData.top.value),
      bottom: Number(formData.bottom.value),
      left: Number(formData.left.value),
      right: Number(formData.right.value),
      hexCode: formData.hexCode.value,
      alignment: formData.alignment.value,
      bold: formData.bold.value,
      italic: formData.italic.value,
      underline: formData.underline.value,
      hyperLink: setHyperLinkValue(),
      ...extraInput,
      index: componentObj?.index > -1 ? componentObj?.index : -1,
      isValid: validate(),
    });
  }, [formData]);

  useEffect(() => {
    handleValidation(formData?.linkedIn);
    handleValidation(formData?.facebook);
    handleValidation(formData?.twitter);
    handleValidation(formData?.instagram);
    handleValidation(formData?.youTube);
  }, []);

  return (
    <div className='text-component'>
      <div className='d-flex justify-content-between'>
        <p className='edit-image'>
          {componentId === EMAIL_TEXT_COMPONENT ? 'Edit Text' : 'Edit Social Handles'}
        </p>
        {isRemovable && (
          <p className='edit-image remove-text' onClick={() => onRemoveComponent()}>
            Remove
          </p>
        )}
      </div>
      <div className='mt-3'>
        <CustomTextField
          item={formData.text}
          handleInputChange={(e) =>
            setFormData({
              text: e,
              hyperLink: {
                ...formData.hyperLink,
                value: e.value ? formData.hyperLink.value : [],
              },
            })
          }
          multiline={true}
          maxLength={maxLength ? maxLength : '300'}
        />
      </div>
      {isFontStyleDD && (
        <div className='mt-3'>
          <CustomSelect
            valueField='id'
            labelField='name'
            item={formData.fontStyle}
            handleInputChange={(e) => {
              setFormData({ fontStyle: e });
            }}
            options={FONT_STYLE_LIST}
            hideNullOption={true}
          />
        </div>
      )}
      <div className='mt-3 row'>
        <div className='col-8'>
          <CustomSelect
            valueField='id'
            labelField='name'
            item={formData.font}
            handleInputChange={(e) => {
              setFormData({ font: e });
            }}
            options={FONT_LIST}
            hideNullOption={true}
          />
        </div>
        <div className='col-4 ps-1'>
          <CustomSelect
            valueField='id'
            labelField='name'
            item={formData.fontSize}
            handleInputChange={(e) => {
              setFormData({ fontSize: e });
            }}
            options={FONT_SIZE_LIST}
            hideNullOption={true}
          />
        </div>
        <div className='row mt-3'>
          <div className='d-flex justify-content-between align-items-center'>
            <span
              onClick={() =>
                setFormData({
                  bold: { ...formData.bold, value: !formData.bold.value },
                })
              }
            >
              <FormatBoldIcon
                className={`pointer ${formData.bold.value ? 'text-component-alignment' : ''}`}
              />
            </span>
            <span
              onClick={() =>
                setFormData({
                  italic: {
                    ...formData.italic,
                    value: !formData.italic.value,
                  },
                })
              }
            >
              <FormatItalicIcon
                className={`pointer ${formData.italic.value ? 'text-component-alignment' : ''}`}
              />
            </span>
            <span
              onClick={() =>
                setFormData({
                  underline: {
                    ...formData.underline,
                    value: !formData.underline.value,
                  },
                })
              }
            >
              <FormatUnderlinedIcon
                className={`pointer ${formData.underline.value ? 'text-component-alignment' : ''}`}
              />
            </span>
            <Divider orientation='vertical' sx={{ height: '30px !important' }} />
            <FormatColorTextIcon />
            <span
              className='background-color-display me-2'
              style={{
                backgroundColor: formData.textColor.value || '#82828214',
              }}
              onClick={() => setIsHsxColor(!isHsxColor)}
            ></span>

            <Divider orientation='vertical' sx={{ height: '30px !important' }} />
            <span
              onClick={() =>
                setFormData({
                  alignment: { ...formData.alignment, value: 'left' },
                })
              }
            >
              <FormatAlignLeftIcon
                className={`pointer ${
                  formData.alignment.value === 'left' ? 'image-component-alignment' : ''
                }`}
              />
            </span>
            <span
              onClick={() =>
                setFormData({
                  alignment: { ...formData.alignment, value: 'center' },
                })
              }
            >
              <FormatAlignCenterIcon
                className={`pointer ${
                  formData.alignment.value === 'center' ? 'image-component-alignment' : ''
                }`}
              />
            </span>
            <span
              onClick={() =>
                setFormData({
                  alignment: { ...formData.alignment, value: 'right' },
                })
              }
            >
              <FormatAlignRightIcon
                className={`pointer ${
                  formData.alignment.value === 'right' ? 'image-component-alignment' : ''
                }`}
              />
            </span>
          </div>
          {isHsxColor && (
            <CustomTextField
              item={formData.textColor}
              handleInputChange={(e) => {
                setFormData({ textColor: e });
              }}
            />
          )}
          {componentId === EMAIL_SOCIAL_TEXT_COMPONENT && (
            <>
              <div className='mt-3'>
                <CustomTextField
                  item={formData.linkedIn}
                  handleInputChange={(e) => {
                    setFormData({ linkedIn: e });
                  }}
                  maxLength='1000'
                />
              </div>
              <div className='mt-3'>
                <CustomTextField
                  item={formData.facebook}
                  handleInputChange={(e) => {
                    setFormData({ facebook: e });
                  }}
                  maxLength='1000'
                />
              </div>
              <div className='mt-3'>
                <CustomTextField
                  item={formData.twitter}
                  handleInputChange={(e) => {
                    setFormData({ twitter: e });
                  }}
                  maxLength='1000'
                />
              </div>
              <div className='mt-3'>
                <CustomTextField
                  item={formData.instagram}
                  handleInputChange={(e) => {
                    setFormData({ instagram: e });
                  }}
                  maxLength='1000'
                />
              </div>
              <div className='mt-3'>
                <CustomTextField
                  item={formData.youTube}
                  handleInputChange={(e) => {
                    setFormData({ youTube: e });
                  }}
                  maxLength='1000'
                />
              </div>
            </>
          )}
        </div>
        {isHyperlink && (
          <div className='mt-3'>
            <Hyperlink formData={formData} setFormData={setFormData} />
          </div>
        )}
        <div className='mt-3'>
          <PaddingComponent formData={formData} setFormData={setFormData} />
        </div>
        <div className='mt-2'>
          <DividerLine />
        </div>
        {isHex && (
          <div className='my-5'>
            <BackgroundColor
              formData={formData}
              setFormData={setFormData}
              title='Background Color'
              fieldKey='hexCode'
            />
          </div>
        )}
        {isVariable && (
          <>
            <DividerLine />
            <div
              className='mt-3 '
              style={{
                color: '#828282',
              }}
            >
              <h6>Variable keywords</h6>
              <p>Add Variables by using keywords from the list within '[ ]', Example: [name]</p>
              <div className='d-flex justify-content-end mt-2'>
                <button
                  className='btn btn-outline-secondary px-3 py-2'
                  onClick={() => handleOpen()}
                >
                  View List
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <div className='container restaurant-modal'>
            <div className=' d-flex align-items-center flex-column'>
              <div className='row w-100 mt-1 align-items-center justify-content-between'>
                <div className='col-md-8'>
                  <span className='header-title'>Variable List for Check-in Confirmation</span>
                </div>
                <div className='col-md-1 d-flex justify-content-end'>
                  <IconButton onClick={(e) => handleClose()}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className='row d-flex align-items-center mt-4 header-row ms-2'>
              <div className='col-4 ms-3 table-header-item'>Variable type</div>
              <div className='col-4 table-header-item'>Variable Keyword</div>
            </div>
            <div>
              <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
                <div className='col-4 ms-3 table-item'>Gender</div>
                <div className='col-4 ms-3 table-item'>[gender]</div>
              </div>
            </div>
            <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
              <div className='col-4 ms-3 table-item'>First name</div>
              <div className='col-4 ms-3 table-item'>[firstname]</div>
            </div>
            <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
              <div className='col-4 ms-3 table-item'>Last name</div>
              <div className='col-4 ms-3 table-item'>[lastname]</div>
            </div>
            <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
              <div className='col-4 ms-3 table-item'>Check-in Date</div>
              <div className='col-4 ms-3 table-item'>[checkin]</div>
            </div>
            <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
              <div className='col-4 ms-3 table-item'>Check-out Date</div>
              <div className='col-4 ms-3 table-item'>[checkout]</div>
            </div>
            <div className='row d-flex align-items-center mt-1 table-row ms-2 py-3'>
              <div className='col-4 ms-3 table-item'>Reservation ID/Confirmation ID</div>
              <div className='col-4 ms-3 table-item'>[reservationid]</div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default TextComponent;
